import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, Shield, Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useConsent } from '@/contexts/ConsentContext';
import CookiePreferencesModal from './CookiePreferencesModal';

const CookieBanner = () => {
  const { showBanner, acceptAll, rejectNonEssential, loading } = useConsent();
  const [showPreferences, setShowPreferences] = useState(false);

  // Não mostrar se estiver carregando ou se o banner não deve ser mostrado
  if (loading || !showBanner) {
    return null;
  }

  return (
    <>
      <AnimatePresence>
        {showBanner && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
          >
            <div className="mx-auto max-w-7xl">
              <div className="rounded-lg border border-border bg-card shadow-lg backdrop-blur-sm">
                <div className="p-6">
                  <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                    {/* Conteúdo do Banner */}
                    <div className="flex flex-1 flex-col gap-3 md:flex-row md:items-start md:gap-4">
                      {/* Ícone */}
                      <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-primary/10">
                        <Cookie className="h-6 w-6 text-primary" />
                      </div>

                      {/* Texto */}
                      <div className="flex-1">
                        <h3 className="mb-2 flex items-center gap-2 text-lg font-semibold text-foreground">
                          <Shield className="h-5 w-5" />
                          Sua Privacidade é Importante
                        </h3>
                        <p className="text-sm text-muted-foreground">
                          Utilizamos cookies essenciais para o funcionamento do site e cookies opcionais para melhorar
                          sua experiência. Você pode escolher quais categorias deseja aceitar ou personalizar suas
                          preferências.
                        </p>
                        <p className="mt-2 text-xs text-muted-foreground">
                          Ao continuar navegando, você concorda com nossa{' '}
                          <a href="/privacy-policy" className="text-primary underline hover:text-primary/80">
                            Política de Privacidade
                          </a>
                          .
                        </p>
                      </div>
                    </div>

                    {/* Botões de Ação */}
                    <div className="flex flex-col gap-2 md:flex-shrink-0 md:flex-row">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setShowPreferences(true)}
                        className="w-full md:w-auto"
                      >
                        <Settings className="mr-2 h-4 w-4" />
                        Personalizar
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={rejectNonEssential}
                        className="w-full md:w-auto"
                      >
                        Rejeitar Não Essenciais
                      </Button>
                      <Button
                        size="sm"
                        onClick={acceptAll}
                        className="w-full md:w-auto"
                      >
                        Aceitar Todos
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal de Preferências */}
      <CookiePreferencesModal
        open={showPreferences}
        onOpenChange={setShowPreferences}
      />
    </>
  );
};

export default CookieBanner;
